export const Tabs = {
    OverviewTab: "OverviewTab",
    ProgramTab: "ProgramTab",
    AdTab: "AdTab",
    ChannelTab: "ChannelTab",
}

export const MeasureSumMode = {
    PROVIDER: { key: "PROVIDER", label: "Channel" },
    FILMCODE: { key: "FILMCODE", label: "Film code" },
    DAY: { key: "DAY", label: "Day" },
    WEEK: { key: "WEEK", label: "Week" },
}
